import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as reducks from '../../../reducks'
import Text from '../../commons/Text/Text'
import RecoveryPasswordForm from './RecoveryPasswordSentEmailForm'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import FlameSantander from '../../commons/Icons/FlameSantander'
import Flex from '../../commons/Flex/Flex'
import styles from './RecoveryPasswordEmail.module.scss'

const RecoveryPasswordSentEmailContainer = () => {
  const dispatch = useDispatch()
  const handleSubmit = (data) =>
    dispatch(reducks.resources.users.actions.resetPasswordSentEmail(data))
  const error = useSelector((state) => state.usersReducer.content.error)

  return (
    <ExternalLayout className={styles.container}>
      <Flex column>
        <div className={styles.logoSantander}>
          <FlameSantander />
        </div>
        <Text
          color="gray"
          variation="dark"
          size="lg"
          bold
          inline
          margin="10px 0px"
        >
          Redefinição da sua senha.
        </Text>
        <Text color="gray" variation="dark" size="md" margin="10px 0px">
          Você receberá um e-mail com um link para redefinição de senha
        </Text>
      </Flex>

      <RecoveryPasswordForm handleSubmit={handleSubmit} error={error} />
    </ExternalLayout>
  )
}

export default RecoveryPasswordSentEmailContainer
